import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'checklistTaskCount'
  ]

  decrement () {
    this.checklistTaskCountTarget.value = Math.max(parseInt(this.checklistTaskCountTarget.dataset.originalCount), parseInt(this.checklistTaskCountTarget.value) - 1)
  }

  increment () {
    this.checklistTaskCountTarget.value = parseInt(this.checklistTaskCountTarget.value) + 1
  }
}
